// Central data-testid registry for NeuroNeeti
export const HOME = { emergentLink: "emergent-link" };

export const SHELL = {
  titleBar: "title-bar",
  sidebar: "sidebar",
  statusStrip: "status-strip",
  workspace: "workspace",
  globalSearch: "global-search",
  commandBtn: "command-btn",
  syncBadge: "sync-badge",
};

export const NAV = {
  dashboard: "nav-dashboard",
  cases: "nav-cases",
  timeline: "nav-surgical-memory-timeline",
  ask: "nav-ask-neuroneeti",
  precase: "nav-pre-case-review",
  mm: "nav-mm-builder",
  library: "nav-knowledge-library",
  analytics: "nav-analytics",
  settings: "nav-settings",
};

export const DASH = {
  root: "dashboard-root",
  kpi: "dashboard-kpi",
  upcomingCase: "dashboard-upcoming-case",
  memoryEntry: "dashboard-memory-entry",
  provenanceTag: "dashboard-provenance-tag",
  quickAsk: "dashboard-quick-ask",
  timelineItem: "dashboard-timeline-item",
};
